import { CheckSquare, Square, Eye, EyeOff } from 'lucide-react'

interface SelectionToolbarProps {
  total: number
  selectedCount: number
  onSelectAll: () => void
  onClear: () => void
  hideUnselected: boolean
  onToggleHideUnselected: () => void
}

/** Per-section selection controls for report/analysis curation — Select All,
 * Clear, and a "Hide unselected" toggle that actually filters what's on
 * screen down to the checked subset. Shared across breaches, web results,
 * stealer logs, and LeakIX services/leaks so every selectable list in
 * BreachINT behaves the same way. */
export function SelectionToolbar({ total, selectedCount, onSelectAll, onClear, hideUnselected, onToggleHideUnselected }: SelectionToolbarProps) {
  return (
    <div className="flex items-center flex-wrap gap-2 mb-1 p-2 bg-black/30 border border-gray-800 rounded-lg">
      <span className="text-xs font-mono text-gray-400 mr-1">
        {selectedCount} / {total} selected
      </span>
      <button
        onClick={onSelectAll}
        className="flex items-center gap-1 px-2 py-1 text-[11px] font-mono rounded border border-gray-700 text-gray-300 hover:bg-gray-800 transition-colors"
      >
        <CheckSquare className="w-3 h-3" /> Select All
      </button>
      <button
        onClick={onClear}
        disabled={selectedCount === 0}
        className="flex items-center gap-1 px-2 py-1 text-[11px] font-mono rounded border border-gray-700 text-gray-300 hover:bg-gray-800 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <Square className="w-3 h-3" /> Clear
      </button>
      <button
        onClick={onToggleHideUnselected}
        className={`flex items-center gap-1 px-2 py-1 text-[11px] font-mono rounded border transition-colors ml-auto ${
          hideUnselected
            ? 'bg-blue-600 text-white border-blue-500'
            : 'border-gray-700 text-gray-300 hover:bg-gray-800'
        }`}
        title="Show only the items you've checked, instead of everything"
      >
        {hideUnselected ? <Eye className="w-3 h-3" /> : <EyeOff className="w-3 h-3" />}
        {hideUnselected ? 'Showing selected only' : 'Hide unselected'}
      </button>
    </div>
  )
}
